/* eslint-disable max-statements */
/* eslint-disable max-lines */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Dropdown, Icon, Table, Input, Popup} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../common/actions';
import {toInteger, toUpperCase} from '../../../common/util/fieldsNormalization';
import {printBinningLabels} from '../../../common/util/print';
import {checkingDateFormat} from '../../../common/constants/datesFormat';
import {setErrorMessage} from '../../../common/components/form/common';
import {tabKeyCode, enterKeyCode} from '../../../common/constants/keyCodes';
import {stopEvent} from '../../../common/util/event';
import BoxSearchModal from './modal/boxSearch';

class CheckingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'storageCar': null,
      'boxWasChecked': false,
      'partCodeWasChecked': false,
      'itemsAmount': 0,
    };
    this.boxInput = [];
    this.partCodeInput = [];
    this.checkedQuantityInput = [];
  }

  componentDidUpdate(prevProps) {
    const {
      boxWasChecked,
      partCodeWasChecked,
      itemsAmount,
    } = this.state;
    const {newItems} = this.props;
    const currentItem = newItems.length - 1;
    if (newItems?.length !== itemsAmount && newItems?.length > 1) {
      const prevLineIndex = newItems.length - 2;
      this.props.updateBinningFields(
        currentItem,
        {
          'storageCar': newItems[prevLineIndex]?.storageCar,
          'date': newItems[prevLineIndex]?.storageCar,
          'box': newItems[prevLineIndex]?.box,
          'boxChecked': true,
        });
      const {selectedInvoice} = this.props;
      this.props.validateBoxBelongInvoice(selectedInvoice, newItems[prevLineIndex]?.box, currentItem);

      const element = document.getElementsByName(`newItems[${currentItem}].partCode`)[0];
      element.focus();
    }

    if (!prevProps.newItems[currentItem] || !newItems[currentItem]) {
      return;
    }

    if (newItems?.length !== itemsAmount) {
      this.setState({'itemsAmount': newItems.length});
    }

    const itemWasSaved = newItems[currentItem].itemSaved;
    const boxChecked = newItems[currentItem].boxChecked;
    if (boxChecked && !boxWasChecked && !itemWasSaved) {
      this.setState({'boxWasChecked': true}, () => {
        const element = document.getElementsByName(`newItems[${currentItem}].partCode`)[0];
        element.focus();
      });
    }

    const partCodeCkecked = newItems[currentItem].partCodeCkecked;
    if (partCodeCkecked && !partCodeWasChecked && !itemWasSaved) {
      this.setState({'partCodeWasChecked': true}, () => {
        const element = document.getElementsByName(`newItems[${currentItem}].checkedQuantity`)[0];
        element.focus();
      });
    }
  }

  getAvailablesStorageCars() {
    const {totalStorageCars, listStorageCarsOccupied} = this.props;
    const freeStorageCars = [];
    for (let i = 1; i <= totalStorageCars; i++) {
      if (listStorageCarsOccupied.indexOf(i.toString()) === -1) {
        freeStorageCars.push(i.toString());
      }
    }
    freeStorageCars.push('G');
    return freeStorageCars.map((car) => ({'text': car, 'value': car}));
  }

  displayError(errorMessage) {
    this.props.addMessageBoxError(errorMessage);
    return false;
  }

  checkRequiredField(value) {
    return value ? null : 'Required';
  }

  labelsPrinter(labels, event) {
    if (typeof labels === 'undefined' || !labels || !labels.length) {
      this.displayError('No se han encontrado etiquetas');
      return;
    }
    printBinningLabels(labels);
  }

  validateBox(index, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }
    stopEvent(event);
    this.setState({'boxWasChecked': false});
    const box = event.target.value;
    const {selectedInvoice} = this.props;
    if (box) {
      this.props.validateBoxBelongInvoice(selectedInvoice, box, index);
      return;
    }
    const {lastBoxSelected} = this.props;
    if (lastBoxSelected) {
      this.props.setLastCheckedBox(index, lastBoxSelected);
      this.props.validateBoxBelongInvoice(selectedInvoice, lastBoxSelected, index);
    }
  }

  validateBoxInOnBlurEvent(index, event) {
    const box = event.target.value;
    if (!box) {
      return;
    }
    this.setState({'boxWasChecked': false});
    const {selectedInvoice} = this.props;
    this.props.validateBoxBelongInvoice(selectedInvoice, box, index);
  }

  verifyLineInfo(item, index, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }
    stopEvent(event);
    this.setState({'partCodeWasChecked': false});
    const partCode = event.target.value;
    if (!partCode) {
      return;
    }
    const invoice = this.props.selectedInvoice;
    const box = item.box;
    this.props.verifyInvoiceLineInfo({invoice, box, partCode}, index);
  }

  saveCheckedQuantity(index, {element, fields}, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode) || element.itemSaved) {
      return;
    }

    stopEvent(event);
    const isValidStorageCar = this.validateStorageCar(element.storageCar);
    const isValidCheckedQuantity = this.validateCheckedQuantity(
      element.checkedQuantity,
      element.expectedQuantity,
      element.receivedQuantity
    );
    if (!isValidStorageCar || !isValidCheckedQuantity) {
      return;
    }
    const invoice = this.props.selectedInvoice;
    const box = element.box;
    const partCode = element.partCode;
    const data = {
      'date': element.date,
      'location': element.location,
      'checkedQuantity': element.checkedQuantity,
      'storageCar': element.storageCar,
    };
    this.props.saveInvoiceLineInfo({invoice, box, partCode}, index, data);
  }

  validateStorageCar(storageCar) {
    return !storageCar ? this.displayError('Debe seleccionar un coche') : true;
  }

  validateCheckedQuantity(checkedQuantity, expectedQuantity, receivedQuantity) {
    let errorMessage = '';
    if (!checkedQuantity) {
      errorMessage = 'Debe ingresar un valor entero en el campo Conteo Físico';
    } else if (!Number.isInteger(checkedQuantity)) {
      errorMessage = 'Verifique el valor ingresado, no puede ser número decimal';
    } else if (checkedQuantity.toString().length > 10) {
      errorMessage = 'La longitud del valor ingresado no puede ser mayor a 10 digitos';
    }
    const checkedQuantityMaxAllowed = parseInt(expectedQuantity, 10) - parseInt(receivedQuantity, 10);
    if (checkedQuantity === 0 || checkedQuantity > checkedQuantityMaxAllowed) {
      errorMessage = `Verifique el valor ingresado, no puede ser 0 ni mayor a ${checkedQuantityMaxAllowed}`;
    }
    return errorMessage !== '' ? this.displayError(errorMessage) : true;
  }

  storageCarsSelected(index, value) {
    this.setState({'storageCarSelected': value});

    if (this.boxInput[index]) {
      return this.boxInput[index];
    }
  }

  renderStorageCarsDropdown = (field) => {
    const {newItems} = this.props;
    const inputValues = (newItems?.length || 0) >= 2 ? {'autoFocus': false} : {'autoFocus': true};
    return (
      <Dropdown
        selection
        upward={field.index > 3}
        options={field.options}
        defaultValue={field.defaultValue}
        search
        searchInput={inputValues}
        onChange={(e, {value}) => {
          field.input.onChange(value);
          this.storageCarsSelected(field.index, value);
        }}
        closeOnChange
        disabled={field.disabled}
        loading={field.loading}
        placeholder={'Co'}
        noResultsMessage='Coche no encontrado'
      />
    );
  }

  renderRowBoxValue({item, element, index, selectedInvoice, invoiceInfo, storageCar, savingLineInfo}) {
    if (element.itemSaved) {
      return element.box;
    }

    return (
      <div>
        <Field
          name={`${item}.box`}
          type='text'
          className='box-input'
          component={Input}
          required
          autoComplete='off'
          disabled={element.itemSaved || !storageCar || savingLineInfo}
          validate={this.checkRequiredField}
          onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
          onInput={(event) => setErrorMessage('', event)}
          normalize={toUpperCase}
          onKeyDown={this.validateBox.bind(this, index)}
          onBlur={this.validateBoxInOnBlurEvent.bind(this, index)}
          placeholder='Caja No'
          ref={(input) => {
            this.boxInput[index] = input;
          }}
        />
        <BoxSearchModal
          invoice={selectedInvoice}
          index={index}
          partLength={invoiceInfo.partLength || 12}
          saving={savingLineInfo}
          itemSaved={element.itemSaved}
        />
      </div>
    );
  }

  renderRowPartCodeValue({item, element, index, savingLineInfo}) {
    if (element.itemSaved) {
      return element.partCode;
    }

    return (
      <Field
        name={`${item}.partCode`}
        type='text'
        component={Input}
        required
        autoComplete='off'
        disabled={element.itemSaved || !element.box || !element.boxChecked || savingLineInfo}
        validate={this.checkRequiredField}
        onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
        onInput={(event) => setErrorMessage('', event)}
        normalize={toUpperCase}
        onKeyDown={this.verifyLineInfo.bind(this, element, index)}
        placeholder='Código'
        ref={(input) => {
          this.partCodeInput[index] = input;
        }}
      />
    );
  }

  renderRowCheckedQuantity({fields, item, element, index, savingLineInfo}) {
    if (element.itemSaved) {
      return element.checkedQuantity;
    }

    return (
      <Field
        name={`${item}.checkedQuantity`}
        type='number'
        component={Input}
        required
        autoComplete='off'
        validate={this.checkRequiredField}
        normalize={toInteger}
        disabled={element.itemSaved || !element.partCodeCkecked || !element.partCode || savingLineInfo}
        min='1'
        step='1'
        max='9999999999'
        onInvalid={(event) => setErrorMessage('Por favor, llene este campo solo con enteros mayores a cero', event)}
        onInput={(event) => setErrorMessage('', event)}
        onKeyDown={this.saveCheckedQuantity.bind(this, index, {element, fields})}
        placeholder='Conteo Físico'
        ref={(input) => {
          this.checkedQuantityInput[index] = input;
        }}
      />
    );
  }

  getFieldsElement = (fields, index, availablesStorageCars) => {
    const {storageCarSelected} = this.state;
    const element = fields.get(index);
    
    if ((!element.itemSaved && !element.storageCar) ||
      (!element.itemSaved && element.storageCar !== storageCarSelected)) {
      const defaultElement = {
        ...element,
        'storageCar': storageCarSelected || availablesStorageCars[0].value,
      };
      return defaultElement;
    }
    return element;
  }

  render() {
    const {savingLineInfo, invoiceInfo, fields, selectedInvoice} = this.props;

    return fields.map((item, index) => {
      const availablesStorageCars = this.getAvailablesStorageCars();
      const element = this.getFieldsElement(fields, index, availablesStorageCars);
      const dateFormatted = element.date ? moment(element.date).format(checkingDateFormat) : '';
      const storageCar = element.storageCar;
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center' className='storage-car-column'>
            {element.itemSaved && element.storageCar}
            {!element.itemSaved && (
              <Field
                name={`${item}.storageCar`}
                component={this.renderStorageCarsDropdown}
                options={availablesStorageCars}
                defaultValue={storageCar}
                index={index}
                disabled={savingLineInfo}
              />
            )}
          </Table.Cell>
          <Table.Cell textAlign='center' className='date-column'>
            {dateFormatted.toUpperCase()}
          </Table.Cell>
          <Table.Cell textAlign='center' className='box-column'>
            {this.renderRowBoxValue({
              item,
              element,
              index,
              selectedInvoice,
              invoiceInfo,
              storageCar,
              savingLineInfo,
            })}
          </Table.Cell>
          <Table.Cell textAlign='center' className='part-code-column'>
            {this.renderRowPartCodeValue({item, element, index, savingLineInfo})}
          </Table.Cell>
          <Table.Cell textAlign='center' className='part-name-column'>
            {element.partName}
          </Table.Cell>
          <Table.Cell textAlign='center' className='location-column'>
            {element.location}
          </Table.Cell>
          <Table.Cell textAlign='center' className='stock-column'>
            {element.stock}
          </Table.Cell>
          <Table.Cell textAlign='center' className='expected-quantity-column'>
            {element.expectedQuantity}
          </Table.Cell>
          <Table.Cell textAlign='center' className='received-quantity-column'>
            {element.receivedQuantity}
          </Table.Cell>
          <Table.Cell textAlign='center' className='back-order-column'>
            {element.backOrders}
          </Table.Cell>
          <Table.Cell textAlign='center' className='label-column'>
            {element.labelsCount}
          </Table.Cell>
          <Table.Cell textAlign='center' className='quantity-column'>
            {this.renderRowCheckedQuantity({fields, item, element, index, savingLineInfo})}
          </Table.Cell>
          <Table.Cell textAlign='center' className='print-column'>
            <Popup
              trigger={
                <Icon
                  name='print'
                  color='blue'
                  size='large'
                  onClick={(event) => this.labelsPrinter(element.labels, event)}
                />
              }
              content='Imprimir'
              position='top center'
              inverted
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }
}

const mapStateToProps = (state) => {
  return {
    'invoiceInfo': state.checking.invoiceInfo,
    'totalStorageCars': state.checking.totalStorageCars,
    'loadingLinesStatus': state.checking.loadingLinesStatus,
    'listStorageCarsOccupied': state.checking.listStorageCarsOccupied,
    'savingLineInfo': state.checking.savingLineInfo,
    'lastBoxSelected': state.form.checking.lastBoxSelected,
  };
};

const {
  validateBoxBelongInvoice,
  setLastCheckedBox,
  verifyInvoiceLineInfo,
  saveInvoiceLineInfo,
  addMessageBoxError,
  updateBinningFields,
} = Actions;

export default connect(mapStateToProps,
  {
    validateBoxBelongInvoice,
    setLastCheckedBox,
    verifyInvoiceLineInfo,
    saveInvoiceLineInfo,
    addMessageBoxError,
    updateBinningFields,
  }
)(CheckingDetail);
